import {EditingNode} from '@wandb/cg/browser/graphEditing/types';
import * as Types from '@wandb/cg/browser/model/types';
import * as CG from '@wandb/cg/browser/graph';
export const inputType = 'any' as const;

export interface PanelExpressionConfig {
  exp: EditingNode;
  panelId: string | undefined;
  panelConfig: any;
  panelInputType: Types.Type;

  // Temporary state to determine if any updates were performed with
  // weave backend enabled. This should be removed once weave python
  // gets to TS parity
  __weaveBackendRequired__?: boolean;
}

export const EMPTY_EXPRESSION_PANEL: PanelExpressionConfig = {
  exp: CG.voidNode(),
  panelId: undefined,
  panelConfig: null,
  panelInputType: 'invalid',
};
